// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Legacy redirect route for /projects/{projectKey}/attachments.
 * Files and links moved from a tab to the right gutter of the project
 * details page, so old tab URLs land on the project details page.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/projects/$projectKey/attachments')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/projects/$projectKey',
      params: { projectKey: params.projectKey },
      search: true,
    });
  },
});
